import { ListItemButton, ListItemButtonProps, ListItemIcon, styled } from '@mui/material'

const StyledListItemBottom = styled(ListItemButton)`
  justify-content: center;
`

export const StyledDarkListItemButton = styled(StyledListItemBottom)<ListItemButtonProps>(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  backgroundColor: theme.palette.secondary.main,
  // eslint-disable-next-line @typescript-eslint/naming-convention -- mui 样式覆盖
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
  },
}))

export const StyledListItemIcon = styled(ListItemIcon)`
  justify-content: center;
`
